export type TabKey = 'membership' | 'faq' | 'support';

export const TAB_LIST: {
  key: TabKey;
  label: string;
}[] = [
  { key: 'membership', label: '멤버십 이용내역' },
  { key: 'faq', label: 'FAQ' },
  { key: 'support', label: '1:1 문의' },
];

export const DEFAULT_TAB: TabKey = 'membership';

export const FAQ_CATE_KR = {
  all: '전체보기',
  Q1: '서비스 이용',
  Q2: '마켓 연동',
  Q3: '매출/정산',
  Q4: '정보 보호',
  QF: '기타',
};

//
export const FAQ_KR = [
  {
    cate: 'Q1',
    q: '셀러박스란 어떤 서비스인가요?',
    a: '여러 오픈마켓에 흩어져있는 판매 내역을 통합하여 관리할 수 있는 서비스입니다. 주문 내역부터 배송, 반품, 리뷰, 고객 유입, 정산 처리까지 나의 쇼핑을 쉽고 편리하게 관리 할 수 있도록 도와주는 무료 서비스입니다.',
  },
  {
    cate: 'Q1',
    q: '셀러박스의 주요 기능은 무엇인가요?',
    a: '마켓별 매출, 정산금액, 배송현황, 반품사유, 사용자 리뷰, 고객 유입까지 한 눈에 확인할 수 있습니다.',
  },
  {
    cate: 'Q1',
    q: '서비스를 해지하고 싶습니다.',
    a: '셀러박스 App에서 설정 > 계정관리 > 서비스 해지 메뉴에서 서비스를 해지할 수 있습니다.',
  },
  {
    cate: 'Q1',
    q: '서비스는 무료로 이용할 수 있나요?',
    a: '네, 셀러박스의 기본 통계 기능은 평생 무료로 제공됩니다.',
  },
  {
    cate: 'Q1',
    q: '오래된 휴대폰에서도 동작하나요?',
    a: '안드로이드는 5.x 버전 이상, 아이폰은 iOS 10 버전 이상에서 동작합니다.',
  },
  {
    cate: 'Q2',
    q: '마켓 연동이 잘 되지 않습니다.',
    a: '판매 중인 마켓 아이디, 패스워드를 정확하게 입력하셨는지 다시 한번 확인해주세요. 연동에 어려움을 겪고 계시다면 help@cplat.io로 문의 남겨주시면 신속히 확인하겠습니다.',
  },
  {
    cate: 'Q2',
    q: '제가 판매하는 오픈마켓은 리스트에 없는데 언제 연동되나요?',
    a: '셀러박스는 현재도 연동가능한 마켓을 늘이고 있습니다. 추가로 연동할 수 있는 마켓이 준비되면 푸시 메세지로 알려드리겠습니다.',
  },
  {
    cate: 'Q2',
    q: '등록된 마켓 계정을 수정하거나 삭제하고 싶어요.',
    a: '셀러박스 App에서 설정 > 마켓관리 > 오픈마켓 연동 메뉴에서 마켓별로 추가, 수정, 삭제하실 수 있어요.',
  },
  { cate: 'Q2', q: '마켓 연동 수는 제한이 없나요?', a: '네, 마켓 연동에는 제한이 없습니다.' },
  {
    cate: 'Q3',
    q: '매출데이터가 안 맞는 것 같아요.',
    a: '연동한 마켓에서 제공하는 매출 집계데이터를 기준으로 보여드리고 있습니다.',
  },
  {
    cate: 'Q3',
    q: 'App에서 통계데이터를 계산하는 기준일이 언제인가요?',
    a: '셀러박스는 전일 자정 기준으로 데이터를 집계해 리포트를 드리고, 오전 6시부터 한시간 단위로 매출 데이터를 조회할 수 있습니다.',
  },
  {
    cate: 'Q3',
    q: '입금 예정금액이 맞지 않습니다.',
    a: '기존 마켓에서 표시되는 입금 예정금액 집계데이터와 동일합니다. 셀러박스는 전일 자정 기준으로 데이터를 집계하고 있습니다.',
  },
  {
    cate: 'Q3',
    q: '과거 데이터는 어느 날짜부터 확인할 수 있나요?',
    a: '가입시점부터 과거 1년 데이터 조회가 가능합니다. 이후 셀러박스를 이용하시는 기간 동안의 데이터는 모두 조회됩니다.',
  },
  {
    cate: 'Q3',
    q: '입금 예정금액은 VAT 별도인가요? 포함인가요?',
    a: '입금 예정금액은 VAT포함 금액으로, 마켓 기준과 동일합니다.',
  },
  {
    cate: 'Q3',
    q: '내 통장계좌도 연결해야 하나요?',
    a: '통장계좌 연결 기능은 아직 지원하지 않고 있습니다. 기능 개발이 완료되면 푸시 메세지로 안내드리겠습니다.',
  },
  {
    cate: 'Q4',
    q: '내 판매데이터가 유출될까봐 우려스럽습니다.',
    a: '셀러박스는 개인정보처리취급방침에 따라 철저한 보안 하에서 모든 데이터를 안전하게 처리하고 있습니다. 모든 데이터는 암호화되어 보관되니 안심하게 이용 부탁드립니다.',
  },
  {
    cate: 'Q4',
    q: '사업자등록번호를 변경하려면 어떻게 하나요?',
    a: '셀러박스 App에서 설정 > 마켓관리 > 마켓설정 메뉴에서 마켓별로 추가, 수정, 삭제할 수 있습니다.',
  },
  {
    cate: 'QF',
    q: '리포트 푸시 메시지가 오지 않았습니다.',
    a: '셀러박스 App에서 설정 > 계정관리 > 푸시알림 설정 메뉴에서 푸시메시지 알림 수신이 허용으로 되어 있는지 확인 부탁드립니다.',
  },
];
